import { ReactElement } from 'react';

import { useGeneralStore } from '@/providers/general-store-provider';
import BikeIcon from '../../icon/bikeIcon';
import CarIcon from '../../icon/carIcon';
import { useLocalStore } from '../local.context';
import VehicleFilters from '../vehicle/vehicle.component';
import './tabs.scss';

interface ITabsItemProps {
    title: string;
    icon: ReactElement;
}

const tabs = [
    {
        title: 'Carro',
        icon: <CarIcon />,
    },
    {
        title: 'Moto',
        icon: <BikeIcon />,
    },
];

const Tabs = () => {
    const { vehicleType, setVehicleType } = useGeneralStore();
    const {
        isActiveVehicleTypeFilter,
        setSelectedBrand,
        setSelectedModel,
        setSelectedYear,
        setSelectedVersion,
        setSelectedStateUF,
    } = useLocalStore();

    const handleTabClick = (index: number) => {
        setVehicleType(index);
        setSelectedBrand(undefined);
        setSelectedModel(undefined);
        setSelectedYear(undefined);
        setSelectedVersion(undefined);
        setSelectedStateUF(undefined);
    };

    return (
        <div className="tabs" data-testid="tabs-container" id="tabs-container">
            {isActiveVehicleTypeFilter ? (
                <>
                    <div className="tab-buttons" data-testid="tab-buttons" id="tab-buttons">
                        {tabs.map((tab: ITabsItemProps, index: number) => (
                            <button
                                key={tab.title}
                                className={`tab ${index === vehicleType ? 'active' : ''}`}
                                onClick={() => handleTabClick(index)}
                                data-testid={`tab-button-${index}`}
                                id={`tab-button-${index}`}
                            >
                                {tab.icon}
                                {index === vehicleType ? (
                                    <h2 data-testid={`tab-title-${index}`} id={`tab-title-${index}`}>
                                        {tab.title}
                                    </h2>
                                ) : (
                                    <span data-testid={`tab-title-${index}`} id={`tab-title-${index}`}>
                                        {tab.title}
                                    </span>
                                )}
                            </button>
                        ))}
                        <div className="tab-slider" data-testid="tab-slider" id="tab-slider"></div>
                    </div>
                    <div className="tab-content" data-testid="tab-content" id="tab-content">
                        {<VehicleFilters />}
                    </div>
                </>
            ) : (
                <div className="tab-content" data-testid="tab-content" id="tab-content">
                    <VehicleFilters />
                </div>
            )}
        </div>
    );
};

export default Tabs;
